import { React, useState, useEffect, useRef } from "react";
import APIUrls from "../../../services/APIUrls";
import {
  downloadFile,
  getAxiosResponse,
  postAxiosResponse,
  putAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ReactMultiSelect from "../../global/ReactMultiSelect";
import CustomProgressBar from "../../global/CustomProgressBar";
import DataTable, { createTheme } from "react-data-table-component";
import $ from "jquery";
import {dateFormat, getHTMLfromText, transformBlankToNull, wrapperText} from "../../../services/Util";
import axios from "axios";
import { useSelector } from "react-redux";
import Select, { components, ValueContainerProps } from "react-select";
import { compareDateWithCurrent } from "../../../services/Util";
import ProjectCustomTaskForm from "./ProjectCustomTaskForm";
import EditCustomTaskForm from "./EditCustomTaskForm";
import Constants from "../../../Constants";
import { useTranslation } from "react-i18next";
import { getLoggedInUserRole } from "../../../services/Util";
import ReactTooltip from "react-tooltip";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import DateFormat from "../../../pages/DateFormat";
import dateUtil from "../../../services/DateUtil";
import { ConditionalBlock } from "../../../ConditionalBlock";
import { AttachmentIcon, FileIcon, FollowerTooltipIcon } from "../../../AppIcons";
import DateUtil from "../../../services/DateUtil";

export default function Tasks(prop) {
  const chunkSize = Constants.CHUNK_SIZE;
  const { t } = useTranslation();
   const translate = t;
  const navigate = useNavigate();
  const [fileMetaData, setFileMetaData] = useState("");
  const langs = [];
  const projectData = prop.projectDetail.resource.projectResource;
  const filterLang = [{
    label: translate("task_campaign.check_all"),
    value: "all",
  },{
    label: translate("task_campaign.uncheck_all"),
    value: "none",
  }];
  const multiSelectRef = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  langs.push({
    label: prop.projectDetail.displayName[0].sourceLanguage.display,
    value: prop.projectDetail.displayName[0].sourceLanguage.language,
  });
  prop.projectDetail.displayName[0]?.targetLanguages?.map(
    (targetLang, index) => {
      langs.push({ label: targetLang.display, value: targetLang.language });
    }
  );
  filterLang.push({
    label: prop.projectDetail.displayName[0].sourceLanguage.display,
    value: prop.projectDetail.displayName[0].sourceLanguage.code,
  });
  prop.projectDetail.displayName[0]?.targetLanguages?.map(
    (targetLang, index) => {
      filterLang.push({ label: targetLang.display, value: targetLang.code });
    }
  );
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const [showRemider, toggleReminderOption] = useState(false);
  function showModel() {
    document.body.classList.add("modal-open");
  }
  function hideModel() {
    document.body.classList.remove("modal-open");
    $('.focusAdd').trigger('focus');
   $('.inline-flex').removeClass('focusAdd');
  }
  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  const downloadAttachment = (commentId) => {
  };
  const roleArray = getLoggedInUserRole();
  const filterRef = useRef(null);
  const selectRef = useRef(null);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedProjectStatus, setProjectStatus] = useState("");
  const [selectedTaskStatus, setTaskStatus] = useState("");
  const [selectedTypeStatus, setTypeStatus] = useState("");
  const [selectedAssignee, setAssignee] = useState("mine=false");
  const [selectedLanguages, setLanguage] = useState([]);
  const [selectedLanguagesString, setLanguageSting] = useState("");
  const [taskDetail, setTaskDetail] = useState("");
  const [historyPopup, toggleHistoryPopup] = useState(false);
  const [remiderPopup, setReminderPopup] = useState(false);
  const [taskFollowers, setTaskFollowers] = useState([]);
  const [reminderUsers, setReminderUsers] = useState([]);
  const [showSessionUser, setShowSessionUser] = useState(false);
  const [excludeSessionUser, setExcludeSessionUser] = useState(true);
  const [taskIdsForReminder, setTaskIdsForReminder] = useState([]);
  const [reminderMsg, setReminderMsg] = useState("");
  const [recentTaskActivity, setRecentTaskActivity] = useState("");
  const [showTaskDetailSection, setShowTaskDetailSection] = useState(false);
  const [showEditSection, setShowEditSection] = useState(false);
  const [languageString, setLanguageString] = useState("");
  // const [perPage, setPerPage] = useState(10);
  const [ isFileAttached, setIsFileAttached  ] = useState(false)
  const [displayFilter, toggleDisplayFilter] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [type, setType] = useState([]);
  const [selectedfile, setSelectedFile] = useState("");
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [fileSizeExceedStatus,setFileSizeExceedStatus]=useState(false)
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [documentFieldId, setDocumentFileId] = useState(-1);
  const [showCreateTask, toggleCreateTask] = useState(false);
  const param = useParams();
  const projectId = param.id;
  const [pending, setPending] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const taskId = param.tabId;
  
  const handleInputChange = (e) => {
    if(e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  }
  const getTaskAssigneeNames = (tasks) => {
    var assigneeNames = [];
    tasks.map((i) => {
      if (i.status.code === "open") {
        if (i.assigneeVendor) {
          assigneeNames.push(i.assigneeVendor.name + " ( Vendor )");
        } else if (i.assigneeUser && i.assigneeUser.userId === null) {
          assigneeNames.push("Project Followers");
        } else if (i.assigneeUser) {
          assigneeNames.push(
            i.assigneeUser.firstName + " " + i.assigneeUser.lastName
          );
        }
      }
    });

    assigneeNames = assigneeNames.filter(
      (item, i, ar) => ar.indexOf(item) === i
    );
    return assigneeNames;
  };
  const isSessionUserMightBeInRecipientList = (tasks) => {
    var val = tasks.map((i) => {
      if (i.assigneeUser && i.assigneeUser.userId === null) {
        return true;
      } else if (
        i.assigneeUser &&
        i.assigneeUser.userId === custBootstrapDataRedux.user.userId
      ) {
        return true;
      } else {
        return false;
      }
    });
    return val;
  };
  const handleChange = ({ selectedRows }) => {
    if (selectedRows.length > 0) {
      toggleReminderOption(true);
   } else {
      toggleReminderOption(false);
    }
    var assigneeUsers = getTaskAssigneeNames(selectedRows);
    setReminderUsers(assigneeUsers);
    var showSessionUser = isSessionUserMightBeInRecipientList(selectedRows)[0];
    setShowSessionUser(showSessionUser);
    var taskIds = [];
    selectedRows.map((task) => {
      taskIds.push(task.id);
    });
    setTaskIdsForReminder(taskIds);
  };
  const showReminderPopup = () => {
    setReminderPopup(true);
    showModel();
    setTimeout(() => {
      $('.inline-flex').addClass('focusAdd');
      $(".first-focus").trigger("focus");
      $("#reminderMsg").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
         if (e.shiftKey === true) {
            e.preventDefault();
            $("#ConfirmId").trigger("focus");
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel()
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const handleKeyEditflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#reminderMsg").trigger("focus");
      }
    }
  };
  const setReminderForTasks = () => {
    var payload = {
      excludeSessionUser: excludeSessionUser,
      taskIds: taskIdsForReminder,
    };
    if (reminderMsg !== "") {
      payload.messageText = reminderMsg;
    }
    postAxiosResponse(
      APIUrls.CREATE_REMINDER_FOR_TASK(projectId),
      payload
    ).then((res) => {
      setReminderMsg("");
      document.getElementById("reminderMsg").value = "";
      hideModel();
    }).catch(err=>{
      console.error(err)
    })
  };
  
  const [sort, setSort] = useState("");
  const filterToggle = () => {
    displayFilter ? toggleDisplayFilter(false) : toggleDisplayFilter(true);
    $('#activeId2').toggleClass('clickActive')
      $(document).mouseup(function(e) {
        var bannerCont = $('.btn-wrap');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          toggleDisplayFilter(false);
          $(".clickActive").trigger("focus");
          $('#activeId2').removeClass('clickActive')
        }
      });
  };
  const handleEscFocus = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
      toggleDisplayFilter(false);
      $("#activeId2").trigger("focus");
      $('#activeId2').removeClass('clickActive')
    }
  }
  const handleModalFocus = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false') {
      toggleDisplayFilter(false);
      $("#activeId2").trigger("focus");
      $('#activeId2').removeClass('clickActive')
    }
    if (event.target.ariaLabel === 'Language') {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId2").trigger("focus");
      }
    }
    if (event.target.ariaLabel === 'Assigned to') {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId2").trigger("focus");
      }
    }
  }
  useEffect(() => {
    if (displayFilter ) {
      $(".local-filter").css("display", "block");
      $("#activeId2").attr("aria-expanded", "true");
     } else {
      $(".local-filter").css("display", "none");
      $("#activeId2").attr("aria-expanded", "false");
    }
  }, [displayFilter]);

  const addRemoveMe = () => {
    var copyTaskDetail = structuredClone(taskDetail);
    copyTaskDetail.pending = false;
    copyTaskDetail = DateUtil.dateTimestampObjectTransformation(copyTaskDetail, ["createdDate"]);
    var payload = transformBlankToNull(copyTaskDetail);
    putAxiosResponse(APIUrls.UPDATE_TASK_FOLLOWERS(taskDetail.id), payload)
    .then((res) => {
      getFollowers(taskDetail.id);
      setTimeout(() => {
        $('.add-remove-link').trigger('focus')
      }, 200);
    }).catch(err=>{
      handleError(err);
    })
  };

  useEffect(()=>{
    if(taskId){
      showTaskDetail(taskId);
    }
    if(prop.taskId){
      showTaskDetail(prop.taskId);
    }
  },[taskId,prop.taskId]);

  const getTaskFollowButtonState = () => {
    // There are three states we care about here:
    // ADD_FOLLOWER: the user is neither a follower nor the assignee, show the "add follower" button
    // NO_BUTTON: the user is a vendor, or the user is the assignee, so they must remain a follower; show no button
    // REMOVE_FOLLOWER: the user is a follower, show the "remove follower" button
    if (
      custBootstrapDataRedux.roleSet.customerType &&
      (!projectData || projectData.userCanAlterProject) &&
      (!taskDetail.workspace !== "" ||
        projectData.workspace.editableByContextUser)
    ) {
      var contextId = custBootstrapDataRedux.user.userId;
      if (
        taskDetail.assigneeUser !== "" &&
        taskDetail.assigneeUser.userId === contextId
      ) {
        return "NO_BUTTON";
      }
    } else {
      return "NO_BUTTON";
    }
    if (taskFollowers.length > 0) {
      var inFollowers = false;
      var countCustomerUser = 0;
      taskFollowers.map((follower) => {
        if (follower.customerUser) {
          countCustomerUser++;
          if (follower.customerUser.userId === contextId) {
            inFollowers = true;
          }
        }
      }, this);
      if (inFollowers) {
        if (countCustomerUser > 1) {
          return "REMOVE_FOLLOWER";
        } else {
          return "NO_BUTTON";
        }
      }
    }
    return "ADD_FOLLOWER";
  };

  const getFollowers = (id) => {
    getAxiosResponse(
      APIUrls.GET_MOST_RECENT_ACTIVITY_BY_TASK(projectId, id)
    ).then((res) => {
      setRecentTaskActivity(res.data.data);
    }).catch(err=>{
      console.error(err)
    })
    getAxiosResponse(APIUrls.GET_TASK_FOLLOWERS(id)).then((res) => {
      setTaskFollowers(res.data.data);
    }).catch(err=>{
      console.error(err)
    })
  };

  const showTaskDetail = (id) => {
    getAxiosResponse(APIUrls.TASK_BY_ID(id)).then((res) => {
      setTaskDetail(res.data.data);
      setShowTaskDetailSection(true);
      setShowEditSection(false)
      setTimeout(() => {
        $('.backTaskFocus').trigger('focus')
      }, 200);
    }).catch(err=>{
      console.error(err)
    })
    getFollowers(id);
  };
  const keyTaskDetail = (event, id) =>{
    if (event.key === Constants.ENTER) {
      getAxiosResponse(APIUrls.TASK_BY_ID(id)).then((res) => {
        setTaskDetail(res.data.data);
        setShowTaskDetailSection(true);
        setShowEditSection(false)
        setTimeout(() => {
          $('.backTaskFocus').trigger('focus')
        }, 200);
      }).catch(err=>{
        console.error(err)
      })
      getFollowers(id);
    }
  }
  const redirectToTab = (tab) =>{
    prop.funct(tab)
  }
  const showTabWithId = (tab,id) =>{
    prop.showTabWithId(tab,id)
  }
  const keyredirectToTab = (event, tab) =>{
    if (event.key === Constants.ENTER) {
      prop.funct(tab)
    }
  }
  const keyOverviewredirectToTab = (event, tab,langCode) =>{
    if (event.key === Constants.ENTER) {
      if(langCode !== ''){
        prop.funct(tab,langCode)
      }else{
        prop.funct(tab)
      }
    }
  }

  const downloadCommentDiscussion=(comments)=>{
     let urlPath =comments?.attachment?.contentPath
     let basePath = urlPath.substring(0, urlPath.indexOf("/task"));
     let newPath = urlPath.replace(new RegExp(basePath, 'g'), "");
    downloadFile(APIUrls.DOWNLOAD_ASSET_PROJECT_DETAIL_TASK(newPath),comments?.attachment?.filename).then(data=>{
    }).catch(err=>{
      console.error(err)
    })
  }

  const downloadFileAttachmentDiscussion=(file)=>{
   downloadFile(APIUrls.PROJECT_DETAIL_TASK_ATTACHMENT_DOWNLOAD(taskDetail?.id),file).then(data=>{
   }).catch(err=>{
     console.error(err)
   })
 }


  const getTaskUrl = (task) => {
    var url = "/project";
    switch (task.type.originalEnum) {
      case "SELECT_WINNING_BID":
        return (
          <button className="button-link"  onClick={() => redirectToTab('bids')}>
            {task.displayName}
          </button>
        );

      case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
        return (
          <button className="button-link"  onClick={() => redirectToTab('internalTranslator')}>
          {task.displayName}
          </button>
        );
      case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
        url = `/${task.url.substring(1)}`;
        var code = task?.url.split("/").pop()
        
        return (
          <button className="button-link"  onClick={() => showTabWithId('changeOrder',code)}>
            {task.displayName}
          </button>
        );
      case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
        return (
          <button className="button-link"  onClick={() => redirectToTab('changeOrder')}>
            {task.displayName}
          </button>
        );

      case "CUSTOM":
        if(task.project !== ''){
          return (
            <button className="button-link"  onClick={() => redirectToTab('tasks')}>
              {task.displayName}
            </button>
          );
        
        }else{
          return (
            <Link  onClick={(e) => {navigate(`/campaign/${task.project.id}`)}}>
              {task.displayName}
            </Link>
          );
        }

      case "PROJECT_ACCEPT_CANCELLATION":
        return (
          <button className="button-link"  onClick={() => redirectToTab('bids')}>
            {task.displayName}
          </button>
        );

      case "REVIEW_APPROVED_ASSET_NOTES":
        url = `/${task.url.substring(1)}`
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "REQUEST_BIDS_FOR_PROJECT":
        url = `/project/${task.project.id}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "REVIEW_PROJECT_REQUEST":
        return (
          <button className="button-link"  onClick={() => redirectToTab('overView')}>
            {task.displayName}
          </button>
        );

      case "REVIEW_BID_DUE_DATE" : 
      return (
        <button className="button-link"  onClick={() => redirectToTab('overView')}>
          {task.displayName}
        </button >
      );

      case "ASSIGN_USERS_TO_GROUPS":
        url= `/settings/user-management`
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );
      default:
        return "";
    }
  };

  const getTitle=(row)=>{
    if(row.type.originalEnum === "CUSTOM"){
      return (
        <a tabIndex="0" 
          onClick={(e)=>showTaskDetail(row.id)}
          onKeyDown={(e)=>keyTaskDetail(e, row.id)}
          >
          {row.displayName}
        </a>
      )
    }
    if(row.type.originalEnum === "RESPOND_TO_MACHINE_TRANSLATION_QUOTE"){
     return( <button tabIndex="0" className="button-link"
      onClick={() => redirectToTab('machineTranslation')}
      onKeyDown={(e)=>keyredirectToTab(e, 'machineTranslation')}
      >
      {translate(`project_tasks.${row.type.code}`)}
    </button>)
    }
    
    if(row.type.originalEnum === 'REQUEST_BIDS_FOR_PROJECT' || row.type.originalEnum === "SUBMIT_TM_AND_CLOSE_PROJECT" ||
    row.type.originalEnum === 'CONFIGURE_PROJECT_SOURCE' || row.type.originalEnum ==='CONFIGURE_PROJECT_WORKFLOW'){
      return( <button tabIndex="0" className="button-link"
       onClick={() => redirectToTab('overView')}
       onKeyDown={(e)=>keyOverviewredirectToTab(e, 'overView')}
       >
      {translate(`project_tasks.${row.type.code}`)}
     </button>)
     }
     if( row.type.originalEnum === "DELIVER_PROJECT_ASSETS" || row.type.originalEnum === 'REVIEW_PROJECT_ASSETS' || 
     row.type.originalEnum === 'REVISE_PROJECT_ASSETS'){
      return( <button tabIndex="0" className="button-link"
       onClick={() => redirectToTab('overView')}
       onKeyDown={(e)=>keyOverviewredirectToTab(e, 'overView',row.url.split("/").pop())}
       >
      {row.displayName}

     </button>)
     }
     
    return(
        getTaskUrl(row)
    )
  }
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
  };
  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $(".rdt_Table").attr("aria-label","Project Tasks"); 
    $('.rdt_Table input').parent().attr("role","cell")
   })
  const columns = [
    {
      id: "task.name",
      name: "Name",
      minWidth: "350px",
      selector: (row) => row.displayName,
      sortable: true,
      cell: (row) => getTitle(row),
    },
    {
      id: "task.type.display",
      name: "Type",
      sortable: true,
      selector: (row) => row.type?.display,
      cell: (row) => (
        <div>
        {row.taskCategoryDisplay}
        </div>
      ),
    },
    {
      id: "task.assigneeUser",
      name: "Assigned To",
      sortable: true,
      selector: (row) => row.assigneeUser,
      cell: (row) => (
        <div>
        {row?.type?.originalEnum === Constants.CUSTOM && row.assigneeVendor ? `${row.assigneeVendor.name} (Vendor)` : row.assigneeUserName}
        </div>
      ),
    },
    {
      id: "task.assetType",
      name: "Language",
      selector: (row) => row.targetLanguage,
      cell: (row) => (
        <div>
          {row.targetLanguage}
        </div>
      ),
    },
    {
      id: "task.status",
      name: "Task Status",
      selector: (row) => row?.status?.display,
      cell: (row) => (
        <div>
          {row?.status?.display}
        </div>
      ),
    },
    {
      id: "task.dueDate",
      name: "Due Date",
      selector: (row) => row.dueDate,
      cell: (row, date) =>
        row.dueDate !== "" ? (
          <div className='relative'>
            <span className='font-zero setFastpass'><DateFormat date={row.dueDate} /></span>
              <span aria-hidden="true">
                <DateFormat date={row.dueDate} />
              </span>
              <span className="alert-text">
                {wrapperText(dateUtil.pendingStatus(row.dueDate), " (", ")")}
              </span>{" "}
          </div>
        ) : (
          ""
        ),
    },
  ];
  const validations = {
    message: {
      required: "Message is required",
      maxLength: {
        value: 3500,
        message: "Message must be 3500 characters long",
      },
    },
  };
 
  const toogleFromList = (val) => {
    toggleCreateTask(val);
  };

  const showRecentActivity = () => {
    toggleHistoryPopup(true);
    showModel();
    $('.inline-flex').addClass('focusAdd');
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          e.preventDefault();
         if (e.shiftKey === true) {
            e.preventDefault();
          }
        }
      });
      $(".inner-lightbox-panel").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          hideModel()
          $('.focusAdd').trigger('focus');
          $('.inline-flex').removeClass('focusAdd');
        }
      });
    }, 500);
  };
  const editTask = (status) => {
    setShowEditSection(status);
    setShowTaskDetailSection(status);
  };
  const conctString = (taskTypes) => {
    var taskTypeString = "";
    taskTypes.map((taskType, index) => {
      taskTypeString += `&type=${taskType.originalEnum}`;
    });
    return taskTypeString;
  };
  const projectArray = [];
  const taskArray = [];
  const assignieeArray = [];
  const languageArray = [];


  useEffect(() => {
    getAxiosResponse(
      APIUrls.ALL_TASK_TYPES + "?entityType=PROJECT"
    )
      .then((res) => {
        if (res.data !== "") {

          res.data.data.result.map((task) => {
            taskArray.push({
              label: translate(`project_task_filters.${task.code.toLowerCase()}`),

              value: conctString(task.taskTypes),
            });
          });
        }
        const taskArrayWithSelect = [{ label: "All", value: "" }, ...taskArray];
        setType(taskArrayWithSelect);
        setPending(false);
      })
      .catch((err) => {
        handleError(err);
      });
  }, []);
  const assignees = [
    { label: "ALL", value: "mine=false" },
    { label: "Me", value: "mine=true" },
  ];
  const taskStatus = [
    { label: "All", value: "" },
    { label: "Open", value: "&status=OPEN" },
    { label: "Completed", value: "&status=CLOSED" },
    { label: "Rejected", value: "&status=REJECTED" },
    { label: "Cancelled", value: "&status=CANCELLED" },
  ];

  const handlePageChange = (paging) => {
    setPending(true);
    setCurrentPage(paging);
  };


  const fetchTaskData = async (page) => {
    setPending(true);
    await getAxiosResponse(
      APIUrls.TASK_BY_PROJECT(projectId) +
        `?${selectedAssignee}${selectedTaskStatus}${sort}${selectedTypeStatus}${languageString}`
    )
      .then((res) => {
        if (res?.data !== "") {
         let data=res?.data?.data;
         if(data && data.length > 0){
         let finalData=data.map(taskData=>{
            if(taskData.status.code==="closed"){
              return {
                 ...taskData,
                 status:{code:"completed",originalEnum:"COMPLETED",display:"Completed"}
              }
            }
            return taskData;
          })
          setTasks(finalData);
          setTotalRows(res?.data?.data?.resultCount);
         }

        } else {
          setTasks([]);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    setPending(false);
  };


  const handleTaskStatusChange = (event) => {
    var selectedTaskStatus = event.value;
    setTaskStatus(selectedTaskStatus);
  };
  const handleTypeStatusChange = (event) => {
    var selectedTypeStatus = event.value;
    setTypeStatus(selectedTypeStatus);
  };
  const handleAssigneeChange = (event) => {
    var selectedAssignee = event.value;
    setAssignee(selectedAssignee);
  };
  const handleLanguageChange = (value) => {
    setLanguage(value);
    var str = ``;
    var selectedLang = value;
    selectedLang.map((values) => {
      str += `&langs=${values.value}`;
    });
    setLanguageString(str);
  };
  useEffect(() => {
    fetchTaskData(currentPage);
  }, [
    sort,
    currentPage,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedTypeStatus,
    selectedAssignee,
    selectedLanguagesString,
    showCreateTask,
    languageString,
  ]);

  
  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };
  const fileSelection = (e) => {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      setFileUploadProgress(0)
     const fileSizeInBytes = e?.target?.files[0]?.size;
     const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
     if (fileSizeInMB > 50) {
      setFileSizeExceedStatus(true)
    } else {
      setFileSizeExceedStatus(false)
    }
  

    }
  };

    useEffect(()=>{
      if(taskDetail?.id){
        fetchTaskAttachmentMetaData()
      }
    },[taskDetail?.id])

  const fetchTaskAttachmentMetaData=()=>{
    getAxiosResponse(APIUrls.PROJECT_DETAIL_TASK_ATTACHMENT(taskDetail?.id)).then(res=>
      setFileMetaData(res?.data?.data)
    ).catch(err=>{
      console.error(err)
    })
    
  }

  const postMsg = () => {
    document.getElementById("msg-content").value = "";
    const params = new URLSearchParams();
    if (selectedfile === "") {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", true);
      params.set("documentFileId", "");
    }

    const urlWithParams = `${APIUrls.TASK_DISCUSSION_ATTACHMENT_META(
      taskDetail.id
    )}?${params.toString()}`;
    postAxiosResponse(urlWithParams).then((res) => {
      setDocumentFileId(res.data.documentFileId);
      setCurrentChunkIndex(0);
    }).catch(err=>{
      console.error(err)
    })
  };

  useEffect(() => {
    if (currentChunkIndex !== null) {
      setShowProgress(true);
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  const readAndUploadCurrentChunk = () => {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  };

  const uploadChunk = (readerEvent) => {
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getMetadataParams();
    var urlPart = "";
    if (file) {
      urlPart =
        APIUrls.TASK_DISCUSSION_ATTACHMENT(taskDetail.id) +
        `?${params.toString()}`;
    } else {
      urlPart =
        APIUrls.TASK_DISCUSSION_ATTACHMENT(taskDetail.id).replace(
          "/upload",
          ""
        ) + `?${params.toString()}`;
    }
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    axios.post(url, data, { headers }).then((response) => {
      if (selectedfile !== "") {
        const filesize = selectedfile.size;
        const chunks = Math.ceil(filesize / chunkSize) - 1;
        const isLastChunk = currentChunkIndex === chunks;
        if (isLastChunk) {
          setCurrentChunkIndex(null);
          setFileUploadProgress(100);
          setIsFileAttached(false)
          // getData()
          setSelectedFile("");
          showTaskDetail(taskDetail.id);
        } else {
          const chunks = Math.ceil(filesize / chunkSize);
          setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
          setCurrentChunkIndex(currentChunkIndex + 1);
        }
      } else {
        setCurrentChunkIndex(null);
        showTaskDetail(taskDetail.id);
      }
    }).catch(err=>{
      console.error(err)
    })
  };

  const getMetadataParams = () => {
    const params = new URLSearchParams();

    if (selectedfile === "") {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("name", selectedfile.name);
      params.set("size", selectedfile.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", true);
      params.set("fileDataAttribute", "attachment.fileData");
      params.set(
        "documentFileId",
        documentFieldId !== -1 ? documentFieldId : ""
      );
    }

    return params;
  };

  const shouldShowCreateTaskButton = (roleArray) => {
    const isReviewer = roleArray.includes("ROLE_CUSTOMER_REVIEWER");
    const isProjectRequester = roleArray.includes("ROLE_CUSTOMER_PROJECT_REQUESTER");
    const isInternalTranslator = roleArray.includes("ROLE_CUSTOMER_INTERNAL_TRANSLATOR");
  
    return !isReviewer || (isReviewer && (isProjectRequester || isInternalTranslator));
  };

  
  return (
    <>
      <div className="listing-content">
        {!showTaskDetailSection ? (
          !showCreateTask ? (
            <div className="campaign_details-task campaign-form">
              <div className="projects-heading">
                <h5>Project Tasks </h5>
                <div className="btn-wrap">
                  <div className="filter" id="filter">
                    <button
                      id="activeId2"
                      className="dashboard-btn filterTask"
                      onClick={filterToggle}
                      onKeyDown={(e) => handleEscFocus(e)}
                      aria-expanded="false"
                    >
                      <span className="filter-icon">
                        <svg
                          width="19"
                          height="14"
                          viewBox="0 0 19 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                            fill="#1D4ED8"
                          ></path>
                          <path
                            d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                            fill="#1D4ED8"
                          ></path>
                        </svg>
                      </span>{" "}
                      Filters
                    </button>
                    <div
                      id="filterBtn"
                      className="filter-content flex local-filter"
                      ref={filterRef}
                      onKeyDown={(e) => handleModalFocus(e)}
                    >
                      <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block flex-center mar-bot20">
                          <label>Assigned to</label>
                          <div
                            className="global-dropdown-select all"
                            ref={selectRef}
                          >
                            <Select
                              classNamePrefix="cw"
                              className="global-dropdown-select"
                              value={assignees.filter(function (option) {
                                return option.value === selectedAssignee;
                              })}
                              aria-label="Assigned to"
                              options={assignees}
                              onChange={(e) => handleAssigneeChange(e)}
                            />
                          </div>
                        </div>
                        <div className="global-dropdown-block flex-center mar-bot20">
                          <label>Task Status</label>
                          <div
                            className="global-dropdown-select"
                            ref={selectRef}
                          >
                            <Select
                              classNamePrefix="cw"
                              className="global-dropdown-select"
                              value={taskStatus.filter(function (option) {
                                return option.value === selectedTaskStatus;
                              })}
                              aria-label="Task Status"
                              options={taskStatus}
                              onChange={(e) => handleTaskStatusChange(e)}
                            />
                          </div>
                        </div>
                        <div className="global-dropdown-block flex-center mar-bot20">
                          <label>Type</label>
                          <div
                            className="global-dropdown-select"
                            ref={selectRef}
                          >
                            <Select
                              classNamePrefix="cw"
                              className="global-dropdown-select"
                              value={type.filter(function (option) {
                                return option.value === selectedTypeStatus;
                              })}
                              aria-label="Type"
                              options={type}
                              onChange={(e) => handleTypeStatusChange(e)}
                            />
                          </div>
                        </div>
                        <div className="global-dropdown-block global-multidropdown-check flex-center mar-bot20">
                          <label>Language</label>
                          <div
                            className="global-dropdown-select language-dropdown"
                            ref={selectRef}
                          >
                            <ReactMultiSelect 
                              ref={multiSelectRef} 
                              value={selectedLanguages} 
                              option={filterLang} 
                              callback={handleLanguageChange}
                              ariaLabel={'Language'}
                              placeholder={'Select '}
                              inputChange={handleInputChange}
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {showRemider ? (
                    <button
                      className="btn-bold inline-flex"
                      onClick={showReminderPopup}
                    >
                      Remind
                    </button>
                  ) : (
                    ""
                  )}
                  {shouldShowCreateTaskButton(roleArray) && (
                    <button className="dashboard-btn" onClick={() => toggleCreateTask(true)}>
                      Create Custom Task
                    </button>
                  )}
                </div>
              </div>
              <div className="task-content">
                <div className="datatable-block">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={tasks}
                    defaultSortFieldId={1}
                    responsive
                    striped
                    selectableRows
                    onSelectedRowsChange={handleChange}
                    onSort={handleSort}
                    // paginationServer
                    paginationTotalRows={totalRows}
                    //paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                    onChangePage={handlePageChange}
                    progressPending={pending}
                    noDataComponent={noDataFoundComponent()}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="campaign_details-task-create-form">
              <div className="projects-heading">
                <h5>Create Custom Task</h5>
                <button
                  className="btn-bold"
                  onClick={() => toggleCreateTask(false)}
                >
                  Back to Task List
                </button>
              </div>
              <ProjectCustomTaskForm
                id={projectId}
                funct={toogleFromList}
                taskLangs={langs}
              />
            </div>
          )
        ) : showEditSection ? (
          <div className="campaign_details-task-create-form">
            <EditCustomTaskForm
              id={projectId}
              funct={()=>showTaskDetail(taskDetail?.id)}
              taskLangs={langs}
              taskDetail={taskDetail}
            />
          </div>
        ) : (
          <div>
            <div className="translate-heading">
              <div className="name-card-section p-0">
                <div className="name-card-section-left">
                  <div className="campaign-name">
                    <button
                      onClick={() => setShowTaskDetailSection(false)}
                      className="back-btn backTaskFocus"
                      aria-label="Back to All Project Tasks"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                      >
                        <path
                          d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#4D4D4D"
                        />
                      </svg>
                    </button>
                    <h3>Back to All Project Tasks</h3>
                  </div>
                </div>
                <div className="name-card-section-right"></div>
              </div>
              <div className="campaign-name">
                <h3>{taskDetail?.displayName}</h3>
                <button
                  aria-label="Edit"
                  className="name-edit"
                  onClick={() => editTask(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                  >
                    <path
                      d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                      fill="#1D4ED8"
                    ></path>
                  </svg>
                </button>
              </div>

              <p>
                  <strong>Created by : </strong>
                  <span className="font-zero" >
                  {taskDetail?.creatorName + " on " + taskDetail?.createdDate?.date}
                  </span>
                  <span aria-hidden="true">
                    {taskDetail?.creatorName + " on " }
                    {taskDetail?.createdDate?.date} 
                  </span>
              </p>
              <p>
                <b>Description : </b>
                {getHTMLfromText(taskDetail?.description)}
              </p>
            </div>

            <div className="campaign_details-task campaign-form">

              <div className="projects-contents">
                <div className="order-table table-responsive relative">
                  <table className="sortable mar-bot20" aria-label="Internal Translator">
                    <thead>
                      <tr>
                        <th scope="col">Assigned to</th>
                        {taskDetail?.startDate !== "" ? (
                          <th>Start Date</th>
                        ) : (
                          ""
                        )}
                        {taskDetail?.dueDate !== "" ? <th>Due Date</th> : ""}
                        <th scope="col">Task Status</th>
                        <th scope="col">Task History</th>
                        {custBootstrapDataRedux?.roleSet?.vendorType ? (
                          <th scope="col">
                            Who will receive notifications about this task?
                          </th>
                        ) : taskFollowers?.length > 0 ? (
                          <th scope="col">
                            Who will receive notifications about this task?
                          </th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{taskDetail?.type?.originalEnum === Constants.CUSTOM && taskDetail.assigneeVendor ? `${taskDetail.assigneeVendor.name} (Vendor)` : taskDetail.assigneeUserName}</td>
                        {taskDetail?.startDate !== "" ? (
                          <td>
                            {taskDetail?.startDate?.date}
                          </td>
                        ) : (
                          ""
                        )}
                        {taskDetail?.dueDate !== "" ? (
                          <td>
                            {taskDetail?.dueDate?.date}
                          </td>
                        ) : (
                          ""
                        )}
                        <td>
                          <b>{taskDetail?.status?.display==='Closed'?'Completed':taskDetail?.status?.display}</b>
                        </td>
                        <td>
                          <Link className="inline-flex" onClick={() => showRecentActivity()}>View</Link>
                        </td>
                        {custBootstrapDataRedux.roleSet.vendorType ? (
                          taskDetail.visibleToCustomer ? (
                            <td>Customer ,Vendor</td>
                          ) : (
                            <td>Vendor</td>
                          )
                        ) : taskFollowers?.length > 0 ? (
                          <td>
                            {taskFollowers?.map((follower, index) => {
                              return follower.customerUser ? (
                                taskFollowers?.length > index + 1 ? (
                                  <span key={index}>
                                    {`${follower.customerUser.firstName} ${follower.customerUser.lastName}, `}
                                  </span>
                                ) : (
                                  <span key={index}>
                                    {` ${follower.customerUser.firstName} ${follower.customerUser.lastName}`}
                                  </span>
                                )
                              ) : follower.vendor ? (
                                taskFollowers?.length > index + 1 ? (
                                  <span key={index}>
                                    {`${follower.vendor.name}, `}
                                  </span>
                                ) : (
                                  <span key={index}>
                                    {` ${follower.vendor.name}`}
                                  </span>
                                )
                              ) : null;
                            })}{" "}
                            {getTaskFollowButtonState() === "ADD_FOLLOWER" ? (
                              <Link role="button" className="add-remove-link" aria-label="Add me" onClick={() => addRemoveMe()}>Add me</Link>
                            ) : getTaskFollowButtonState() ===
                              "REMOVE_FOLLOWER" ? (
                              <Link role="button" className="add-remove-link" aria-label="Remove me" onClick={() => addRemoveMe()}>
                                Remove me
                              </Link>
                            ) : null}
                          </td>
                        ) : null}
                      </tr>
                      <tr>{!taskDetail?.isWorkflowTask}</tr>
                    </tbody>
                  </table>
                  <table className="sortable  mar-bot20" aria-label="Closed Date">
                    <thead>
                      <tr>
                        {!taskDetail?.isWorkflowTask ? <th scope="col">Closed Date</th> : ""}
                        {taskDetail?.targetLanguage !== "" ? (
                          <th scope="col">Language</th>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {!taskDetail?.isWorkflowTask ? (
                          taskDetail?.closedDate !== "" ? (
                            <td>
                              {dateFormat(
                                taskDetail?.startDate,
                                Constants.DATE_HOUR_YEAR_MIN_SEC
                              )}{" "}
                            </td>
                          ) : (
                            <td>N/A</td>
                          )
                        ) : (
                          ""
                        )}
                        {taskDetail?.targetLanguage !== "" ? (
                          <td>{taskDetail?.targetLanguage}</td>
                        ) : (
                          ""
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <ConditionalBlock condition={fileMetaData}>
              <><h5 className="heading-width-border mar-bot30">Task attachment</h5>
              <div className="tooltip-container flex">
                <Link onClick={() => downloadFileAttachmentDiscussion(fileMetaData?.filename)}>
                  <span className='attachment-icon'>
                  {AttachmentIcon}
                  </span>
                  {fileMetaData?.filename}
                </Link>
                <p tabindex={0} data-events={['focus']} data-eventsoff={['blur']} data-padding="10px 10px 10px 10px" data-place="right"
                  data-tip data-for={"projectdetailCustomTaskfile"} aria-label="Tooltip" id={"vendorBidTooltipFocus"+"file"} className="m-0">
                  {FollowerTooltipIcon}
                </p>
                <ReactTooltip className="tooltip" id={"projectdetailCustomTaskfile"} >
                  <div className="mar-bot6">
                    <p><strong>Size : </strong> { formatBytes(fileMetaData?.sizeInKilobytes * 1024)}</p>
                    <strong>Files included in this ZIP : </strong>
                    <p>{fileMetaData?.fileContents} </p>
                  </div>
                </ReactTooltip>
              </div></>
            </ConditionalBlock>

            <h5 className="heading-width-border mar-bot30">Discussion</h5>

            <div className="table-responsive">
              <table className="sortable">
                <tbody>
                  {taskDetail?.comments?.length > 0 ? (
                    taskDetail?.comments?.map((comment, index) => {
                      return (
                        <tr key={index}>
                          <td>{comment?.creatorDisplayName}</td>
                          <td>
                            {dateFormat(
                              comment?.createdDate,
                              Constants.DATE_HOUR_YEAR_MIN_SEC
                            )}
                          </td>
                          <td>
                            <strong type="button">{getHTMLfromText(comment.text)}</strong>
                          </td>
                          {comment.attachment !== "" ? (
                            <td>
                                                            <div className="tooltip-container flex-align">

<Link
  onClick={() => downloadCommentDiscussion(comment)}
>
               <span className='attachment-icon'>
<svg className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
<path d="M12.4966 6.0589L11.216 4.85666L4.81261 10.8726C4.56042 11.1097 4.36039 11.3911 4.22394 11.7008C4.08749 12.0105 4.01729 12.3424 4.01735 12.6776C4.01741 13.0128 4.08773 13.3447 4.22428 13.6543C4.36084 13.964 4.56097 14.2454 4.81324 14.4823C5.06551 14.7193 5.36498 14.9073 5.69456 15.0355C6.02413 15.1637 6.37736 15.2297 6.73406 15.2296C7.09077 15.2296 7.44397 15.1635 7.7735 15.0352C8.10303 14.9068 8.40244 14.7188 8.65462 14.4817L16.3387 7.26234C17.1876 6.46441 17.6645 5.38226 17.6644 4.25393C17.6643 3.12561 17.1872 2.04354 16.338 1.24577C15.4889 0.448007 14.3373 -0.000111155 13.1365 2.06817e-08C11.9358 0.000111197 10.7843 0.448443 9.9353 1.24637L1.8677 8.8262L1.85003 8.84162C-0.616678 11.1596 -0.616678 14.9157 1.85003 17.2324C4.31675 19.5492 8.31395 19.5492 10.7807 17.2324L10.7971 17.2158L10.7983 17.217L16.3058 12.0429L15.0252 10.8406L9.51766 16.0136L9.50126 16.029C8.65606 16.8217 7.51072 17.2668 6.31661 17.2668C5.1225 17.2668 3.97716 16.8217 3.13197 16.029C2.71302 15.6345 2.38107 15.1661 2.15514 14.6508C1.92922 14.1354 1.81377 13.5832 1.81541 13.0259C1.81705 12.4685 1.93575 11.9169 2.16471 11.4028C2.39366 10.8886 2.72837 10.422 3.14963 10.0296L3.14837 10.0284L11.2172 2.44861C12.2758 1.45267 13.9994 1.45267 15.0592 2.44861C16.1191 3.44456 16.1178 5.06296 15.0592 6.05772L7.37522 13.2771C7.20325 13.4258 6.97683 13.5062 6.74323 13.5017C6.50963 13.4972 6.28693 13.408 6.12163 13.2528C5.95634 13.0977 5.86124 12.8885 5.85619 12.669C5.85114 12.4495 5.93654 12.2366 6.09454 12.0749L12.4979 6.05772L12.4966 6.0589Z" fill="#1D4ED8"/>
</svg>
</span>
  {comment?.attachment?.filename}
</Link>
    <p
      tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
      data-padding="10px 10px 10px 10px"
      data-place="right"
      data-tip
      data-for={"projectdetailCustomTask"+index}
      aria-label="Tooltip"
      id={"vendorBidTooltipFocus"+index}
      className="m-0"
    >
      <svg
        className="svg-tooltip-icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
      </svg>

    </p>
    <ReactTooltip
      className="tooltip"
      id={"projectdetailCustomTask"+index}
    >
      <div className="mar-bot6">
      
            <p><strong>Size : </strong> { formatBytes(comment?.attachment?.sizeInKilobytes * 1024)}</p>
            <strong>Files included in this ZIP : </strong>
            <p>{comment?.attachment?.fileContents} </p>

           </div>
    </ReactTooltip>
  </div>
                            </td>
                          ) : (
                            <td></td>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="p-0 bgTransparent">
                        <p>
                          No one has discussed this request yet. When someone
                          does, it will show here.
                        </p>
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan="4" className="pl-0 pr-0 bgTransparent">
                      <div className="flex create-task-discussion">
                      <div className="left-uname">
                        <p>{taskDetail?.creatorName}</p>
                      </div>
                      <div className="campaign_details-task-create-form discussion-form">
                        <div className="projects-heading">
                          <h5>Comments</h5>
                        </div>
                        <form onSubmit={handleSubmit(postMsg)}>
                          <div className="task-form-content">
                            <div className="form-group text">
                              <div className="form-text">
                                <label htmlFor="msg-content">Message </label>
                                <textarea
                                  className="textarea"
                                  id="msg-content"
                                  aria-describedby="errorMessage"
                                  placeholder="3500 characters limit"
                                  aria-required='true'
                                  maxLength={3500}
                                  {...register("message", validations.message)}
                                  onChange={(event) =>
                                    setMessage(event.target.value)
                                  }
                                ></textarea>
                                <p
                                  className="error textDanger m-0"
                                  id="errorMessage"
                                >
                                  {errors.message?.message}
                                </p>
                              </div>
                            </div>
                            <div className="flex wrap-dropdown file-btn">
                            {fileSizeExceedStatus ? <p className="textDanger">File size exceeds 50MB.</p>:Constants.BLANK}
                              <div className="file-input flex w-d100">
                              {!isFileAttached ? <>
                                <p>Maximum file size: 50MB. Create a zip file to upload multiple files.</p>
                      
                                <div className="input-file mar-bot16">
                                  <input type="file" id="files" onChange={fileSelection} />
                                  <label className="file-button flex-center" htmlFor="files" >
                                    {!selectedfile ? "Choose file" : "Select a different file"}
                                  </label>
                                </div></>
                                :Constants.BLANK}

                                <div className={ selectedfile ? "uploading-files-block uploading-success w-d100"
                                      : "uploading-files-block uploading-success w-d100 hide" }>
                                  <div className="uploading-file-list flex">
                                    <div className="left-file-desc flex-center">
                                      <div className="icon-block">
                                        {FileIcon}
                                      </div>
                                      <div className="file-text">
                                        <span className="ext-name">
                                          {selectedfile?.name}
                                        </span>
                                        <strong>
                                          <span className="date-name">
                                          <DateFormat date={new Date()} format={null} timezone={null}/>
                                          </span>
                                          <span className="file-size">
                                            {formatBytes(selectedfile?.size)}
                                          </span>
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                  <div className={ showProgress ? "right-progressbar" : "right-progressbar hide" }>
                                    <CustomProgressBar
                                      completed={fileUploadProgress}
                                      labelLineHeight="1px"
                                      labelSize="14px"
                                      width="100%"
                                      labelClassName="progressBarLabel"
                                      borderRadius="30px"
                                      labelAlignment="outside"
                                      labelColor="rgba(0,0,0,0.87)"
                                      height="10px"
                                      className="file_upload_progress"
                                      bgColor="#06B878"
                                      baseBgColor="#D1DEF0"
                                      ariaValuetext={fileUploadProgress}
                                      aria-label=""
                                      aria-valuenow={fileUploadProgress}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex two-col justify-end">
                            <button className={message === "" || fileSizeExceedStatus ? "disabled-data btn btn-bold" : "btn btn-bold"}
                              type="submit" onClick={() => setIsFileAttached(!!selectedfile)}>
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      {historyPopup ? (
        <div id="modelPopup" className="lightbox-panel task-popup bid-extended" aria-labelledby="taskHistory" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel">
            <div className="modal-header flex">
              <strong id="taskHistory">Task History</strong>
            </div>
            <div className="lightbox-content task-form-content">
              {recentTaskActivity?.events?.map((activity, index) => {
                return (
                  <div key={index}>
                    {compareDateWithCurrent(
                      activity.createdDate,
                      Constants.DATE_COMPARE_FORMAT
                    ) ? (
                      <div className="activity-feed-inner">
                        {index === 0 ? (
                          <span
                            className="title"
                            style={{ marginBottom: "8px", fontWeight: "600" }}
                          >
                            {" "}
                            Today
                          </span>
                        ) : (
                          ""
                        )}
                        <ul className="activity-feed-table">
                          <li>
                            <span>
                              {activity.createdDate.timeOfDay}
                              <p>
                                {activity.output.replace(
                                  /<a.*?>.*?<\/a>/gi,
                                  ""
                                )}
                              </p>
                            </span>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <div className="activity-feed-inner">
                        {index !== 0 ? (
                          dateFormat(
                            recentTaskActivity.events[index - 1]?.createdDate,
                            Constants.DATE_COMPARE_FORMAT
                          ) !==
                          dateFormat(
                            recentTaskActivity.events[index].createdDate,
                            Constants.DATE_COMPARE_FORMAT
                          ) ? (
                            <span
                              className="title"
                              style={{ marginBottom: "8px", fontWeight: "600" }}
                            >
                              {activity.createdDate.date}
                            </span>
                          ) : (
                            ""
                          )
                        ) : (
                          <span className="title">
                            {activity.createdDate.date}
                          </span>
                        )}
                        <ul className="activity-feed-table">
                          <li>
                            <span
                              className={
                                index !== 0
                                  ? dateFormat(
                                      recentTaskActivity.events[index - 1]
                                        ?.createdDate,
                                      Constants.DATE_COMPARE_FORMAT
                                    ) !==
                                    dateFormat(
                                      recentTaskActivity.events[index]
                                        .createdDate,
                                      Constants.DATE_COMPARE_FORMAT
                                    )
                                    ? ""
                                    : ""
                                  : ""
                              }
                            >
                              {activity.createdDate.timeOfDay}
                            </span>
                            <p>
                              {" "}
                              {activity.output.replace(
                                /<a.*?>.*?<\/a>/gi,
                                ""
                              )}{" "}
                            </p>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="modal-footer flex">
              <button className="btn btn-bold first-focus" onClick={hideModel}>
                Close
              </button>
            </div>
          </div>
        </div>
      ) : remiderPopup ? (
        <div id="modelPopup" className="lightbox-panel task-popup bid-extended" aria-labelledby="sendReminder" aria-modal="true" role="dialog">
          <div className="inner-lightbox-panel">
            <div className="modal-header flex">
              <strong id="sendReminder">Send Reminder For a Task</strong>
            </div>
            <div className="lightbox-content task-form-content">
              <p>
                This user will receive a reminder from OPAL-Marketing:{" "}
                {reminderUsers.map((user, index) => {
                  if (reminderUsers.length > index + 1) {
                    return <strong key={index}>{user}, </strong>;
                  } else {
                    return <strong key={index}>{user} </strong>;
                  }
                })}
              </p>
              <div className="form-check-outer">
                {showSessionUser ? (
                  <div className="form-check form-check-inner flex-center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="checkbox"
                      value=""
                      defaultChecked={excludeSessionUser}
                      onChange={(e) => setExcludeSessionUser(e.target.checked)}
                      id="Exclude myself from recipient list"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="Exclude myself from recipient list"
                    >
                      Exclude myself from recipient list
                    </label>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="flex textarea-group">
                <div className="task-area flex-center">
                  <label htmlFor="reminderMsg">Add optional message</label>
                  <textarea
                    className="textarea"
                    placeholder="500 characters limit"
                    id="reminderMsg"
                    onChange={(e) => setReminderMsg(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer flex">
              <button className="btn btn-bold first-focus" onClick={hideModel}>
                Cancel
              </button>
              <button
                id="ConfirmId"
                className="btn btn-bold active"
                onClick={setReminderForTasks}
                onKeyDown={handleKeyEditflow}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
